export enum ISP_SUBMIT_MODE {
  /** 預設表單送出模式 */
  DEFAULT = 'default',
  /** 用戶自行輸入社區名稱 */
  NO_COMMUNITY = 'noCommunity'
}